import { gql } from '@apollo/client';

export const GET_PATIENT_QUERY_CSV = gql`
  query GetPatientQueryCSV($data: PatientQueryInput!) {
    getPatientQueryCSV(data: $data) {
      csvUrl
    }
  }
`;
